function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.5 0 L 25.5 0 C 27.984375 0 30 2.015625 30 4.5 L 30 25.5 C 30 27.984375 27.984375 30 25.5 30 L 4.5 30 C 2.015625 30 0 27.984375 0 25.5 L 0 4.5 C 0 2.015625 2.015625 0 4.5 0 Z M 4.5 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.882353%,72.156863%,51.372549%)",
      fillOpacity: 1
    },
    d: "M 17.578125 8.203125 L 15 12.714844 L 12.421875 8.203125 L 3.75 8.203125 L 15 27.714844 L 26.25 8.203125 Z M 17.578125 8.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.784314%,28.627451%,36.862745%)",
      fillOpacity: 1
    },
    d: "M 17.578125 8.203125 L 15 12.714844 L 12.421875 8.203125 L 8.261719 8.203125 L 15 19.921875 L 21.738281 8.203125 Z M 17.578125 8.203125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/vue.cc5132d0886bbfaae13df0096d984356.svg";
export { ForwardRef as ReactComponent };